import { render, staticRenderFns } from "./callUs.vue?vue&type=template&id=179452f2&scoped=true&"
var script = {}
import style0 from "./callUs.vue?vue&type=style&index=0&id=179452f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179452f2",
  null
  
)

export default component.exports